jQuery(document).ready(function($){

    addAdditionalBreakpointsToFullWidth();
    addAdditionalBreakpointsToSplitContent();

    $(window).resize(function(){
        addAdditionalBreakpointsToFullWidth();
        addAdditionalBreakpointsToSplitContent();
    })

    function addAdditionalBreakpointsToFullWidth() {
        $('.full-width-section').each(function () {
            let additionalBreakpoints = $(this).data('additional-breakpoints');
            let i;
            if (additionalBreakpoints) {
                for (i = 0; i < additionalBreakpoints.length; ++i) {
                    let breakpoint = additionalBreakpoints[i]['breakpoint'];
                    let paddingTop = additionalBreakpoints[i]['padding_top'] + 'rem';
                    let paddingBottom = additionalBreakpoints[i]['padding_bottom'] + 'rem';
                    let paddingLeft = additionalBreakpoints[i]['padding_left'] + 'rem';
                    let paddingRight = additionalBreakpoints[i]['padding_right'] + 'rem';

                    if (window.matchMedia(`(min-width: ${breakpoint}px)`).matches) {
                        $(this).css({
                            'paddingTop': paddingTop,
                            'paddingBottom': paddingBottom,
                            'paddingLeft': paddingLeft,
                            'paddingRight': paddingRight,
                        });
                    } else {
                        $(this).css({
                            'paddingTop': '',
                            'paddingBottom': '',
                            'paddingLeft': '',
                            'paddingRight': ''
                        });
                    }
                }
            }
        })
    }

    function addAdditionalBreakpointsToSplitContent() {
        $('.split-content-section').each(function () {
            let additionalBreakpoints = $(this).data('additional-breakpoints');
            let i;
            if (additionalBreakpoints) {
                for (i = 0; i < additionalBreakpoints.length; ++i) {
                    let breakpoint = additionalBreakpoints[i]['breakpoint'];
                    let paddingTop = additionalBreakpoints[i]['padding_top'] + 'rem';
                    let paddingBottom = additionalBreakpoints[i]['padding_bottom'] + 'rem';
                    let paddingLeft = additionalBreakpoints[i]['padding_left'] + 'rem';
                    let paddingRight = additionalBreakpoints[i]['padding_right'] + 'rem';
                    let leftSideWidth = additionalBreakpoints[i]['left_side_width'] + '%';
                    let rightSideWidth = additionalBreakpoints[i]['right_side_width'] + '%';

                    if (window.matchMedia(`(min-width: ${breakpoint}px)`).matches) {
                        $(this).css({
                            'paddingTop': paddingTop,
                            'paddingBottom': paddingBottom,
                            'gridTemplateColumns': leftSideWidth + ' ' + rightSideWidth
                        });
                        $(this).find('.split-content-module__left').css({
                            'paddingLeft': paddingLeft,
                        })
                        $(this).find('.split-content-module__right').css({
                            'paddingRight': paddingRight,
                        })
                    } else {
                        $(this).css({
                            'paddingTop': '',
                            'paddingBottom': '',
                            'gridTemplateColumns': ''
                        });
                        $(this).find('.split-content-module__left').css({
                            'paddingLeft': '',
                        })
                        $(this).find('.split-content-module__right').css({
                            'paddingRight': '',
                        })
                    }
                }
            }
        })
    }

})